import { render } from "./UserRole.vue?vue&type=template&id=2137769f&ts=true"
import script from "./UserRole.vue?vue&type=script&lang=ts"
export * from "./UserRole.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/cibweb-v2-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__